import { URLSearchParams } from "@angular/http";
import { Component } from '@angular/core';

import { UsuarioService } from '../../providers/usuario-service';

@Component({
    selector: 'page-ajuda',
    templateUrl: 'ajuda.html'
})
export class AjudaPage {

    loading: boolean = false;
    loginDoJurisdicionado: boolean = false;
    isJurisdicionado: any;
    usuario: any;

    constructor(private usuarioService: UsuarioService) {
        this.usuario = this.usuarioService.obtemUsuario();

        this.isJurisdicionado = this.usuarioService.isJurisdicionado();
        // usuarioService.getUsuario().subscribe(broadcastVariable => {
        //     this.usuario = broadcastVariable.usr;
        //     if (this.usuario.tipo == 1) {
        //       this.isJurisdicionado = true;
        //     } else {
        //       this.isJurisdicionado = false;
        //     }
        //   });
    }
}



// WEBPACK FOOTER //
// ./src/pages/ajuda/ajuda.ts